module.exports = __webpack_public_path__ + "static/media/my_staff_header.45a19719.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/my_staff_header.jpg
// module id = 2377
// module chunks = 0